export const SET_EDITOR_SESSION_ID = 'SET_EDITOR_SESSION_ID';
export const SET_SHAREDB_CONNECTED = 'SET_SHAREDB_CONNECTED';
